<template>
    <div class="card-orcamento-final-produtoRA">
        <g-card
        :temCabecalho = "false"
        >
            <div class="header-card-resumo-final espacamento-header-resumo-final">
                <div class="resumo-final-imagem">
                    <img class="resumo-final-img" src="@/assets/imgs/icone_orçamento_menor.svg"/>
                </div>

                <div class="titulo-resumo-final"> ORÇAMENTO <div class="container-numero">#<div class="cor-numero">{{orcamento}}</div></div> </div>
                <div class="subtitulo-resumo-final"> CONFIRA AS INFORMAÇÕES SOBRE O ORÇAMENTO </div>

                <div class="linha-separacao"></div>

                <div class="unidade-representante">
                    <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{nomeRepre}}</div></div>
                    <div class="titulo-conteudo-cabecalho"> Unidade: &nbsp; <div class="label-cabecalho">{{Empresa}}</div></div>
                </div>

                <div class="header-icons">
                    <g-button
                    class="botoes"
                    altura="36px"
                    largura="38px"
                    tamanhoIcone="18px"
                    icone="icone_compartilhar.svg"
                    >
                    </g-button>

                    <g-button
                    @click="pdfFinal()"
                    class="botoes"
                    altura="36px"
                    largura="38px"
                    tamanhoIcone="18px"
                    icone="icone_print.svg"
                    >
                    </g-button>
                </div>
            </div>

            <g-pdf :pdfFloat="false" :NovaGuia="true"  :executar="executarvisualizacao">
                <div class="render" v-if="renderiza">
                    <ConsultarOrcamentoPDF :PropstyleImg= "this.styleImg" :PropcaminhoImagem="this.caminhoImagem" :tituloDetalhes="false" v-on:termino="gerarPdf" :orcamentoId="OrcamentoSelecionado"></ConsultarOrcamentoPDF>
                </div>
            </g-pdf>

            <div class="orcamento-final-conteudo espacamento-resumo-final">
                <div class="titulo-grupo-detalhes"> CLIENTE </div>
                <div class="grupo-dados-cliente">
                    <div class="cliente-cnpj">
                        <div class="titulo-conteudo-resumo-final"> CNPJ </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.cnpj}}</div>
                    </div>

                    <div class="cliente-codigo">
                        <div class="titulo-conteudo-resumo-final" > Código </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.codigo}}</div>
                    </div>

                    <div class="cliente-razaosocial">
                        <div class="titulo-conteudo-resumo-final"> Razão Social </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.razaoSocial}}</div>
                    </div>

                    <div class="cliente-estado">
                        <div class="titulo-conteudo-resumo-final"> Estado </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.siglaEstado}}</div>
                    </div>

                    <div class="cliente-cidade">
                        <div class="titulo-conteudo-resumo-final"> Cidade </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.nomeCidade}}</div>
                    </div>

                    <div class="cliente-segmento">
                        <div class="titulo-conteudo-resumo-final"> Segmento </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.clienteTipoTexto}}</div>
                    </div>

                    <div class="cliente-contato">
                        <div class="titulo-conteudo-resumo-final"> Contato </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.nomeContato}}</div>
                    </div>

                    <div class="cliente-telefone">
                        <div class="titulo-conteudo-resumo-final"> Telefone </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.numeroTelefone}}</div>
                    </div>

                    <div class="cliente-ramal">
                        <div class="titulo-conteudo-resumo-final"> Ramal </div>
                        <div class="label-conteudo-resumo-final">{{NumeroRamalExibicao()}}</div>
                    </div>

                    <div class="cliente-suframa">
                        <div class="titulo-conteudo-resumo-final"> Suframa </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoClienteArray.numeroSuframa || 'Não cadastrado'}}</div>
                    </div>

                    <div class="cliente-incentivo">
                        <div class="titulo-conteudo-resumo-final"> Possui incentivo fiscal? </div>
                        <div class="label-conteudo-resumo-final">{{this.ICMS + this.IPI + this.PisCofins == '' ? 'NÃO' : this.ICMS + this.IPI + this.PisCofins}}</div>
                    </div>
                </div>


                <div class="titulo-grupo-detalhes"> LOTE E FRETE </div>
                <div class="grupo-dados-loteFrete">
                    <div class="lotefrete-riscofaca">
                        <div class="titulo-conteudo-resumo-final">Risco Faca</div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.getRiscoFaca}}</div>                        
                    </div>
                    <div class="loteFrete-prototipo">
                        <div class="titulo-conteudo-resumo-final">Protótipo</div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.getPrototipo}}</div>
                    </div>

                    <div class="lotefrete-lote">
                        <div class="titulo-conteudo-resumo-final"> Lote </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.informacaoLoteText}}</div>
                    </div>

                    <div class="loteFrete-descricao-lote" v-if="InformacaoLoteFreteArray.informacaoLoteText !== 'Não'">                            
                        <div class="titulo-conteudo-resumo-final"> Descrição Lote </div>
                        <div class="label-conteudo-resumo-final">{{ DescricaoLote }}</div>
                    </div>

                    <div class="lotefrete-sequencia">
                        <div class="titulo-conteudo-resumo-final"> Sequência </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.getSequencia}}</div>
                    </div>
                    <div class="loteFrete-descricao-sequencia" v-if="InformacaoLoteFreteArray.sequencia != false">                            
                        <div class="titulo-conteudo-resumo-final"> Descrição Sequência </div>
                        <div class="label-conteudo-resumo-final">{{OrcamentoDescricaoSequencia || 'Não possui'}}</div>
                        <div class="label-conteudo-resumo-final" v-for="data in InformacaoProdutosSequencia"
                        :key="data.produtoId">
                        {{ data.tipo }} / {{data.codigoExterno}} - {{data.produto}} 
                    </div>
                    </div>

                    <div class="lotefrete-frete">
                        <div class="titulo-conteudo-resumo-final"> Frete </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.freteEnum}}</div>
                    </div>

                    <div class="lotefrete-estado">
                        <div class="titulo-conteudo-resumo-final"> UF </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.siglaEstado}}</div>
                    </div>

                    <div class="lotefrete-cidade">
                        <div class="titulo-conteudo-resumo-final"> Cidade </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.nomeCidade}}</div>
                    </div>

                    <div class="lotefrete-tipoFrete">
                        <div class="titulo-conteudo-resumo-final"> Tipo Frete </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoLoteFreteArray.tipoFreteEnumTexto || 'Sem Tipo Frete'}}</div>
                    </div>
                </div>

                <div class="titulo-grupo-detalhes"> INFORMAÇÕES BÁSICAS </div>
                <div class="grupo-dados-infoBasicas">
                    <div class="infoBasicas-imagemProduto">
                        <PImage 
                        :imageStyle="styleImg" 
                        v-on:error="erro($event)" 
                        :src="caminhoImagem" 
                        :preview="true"
                        ></PImage>
                        <div class="img-info-mobile" v-if="this.styleImg.includes('100')"> NENHUMA IMAGEM DISPONÍVEL! </div>
                    </div>

                    <div class="infoBasicas-nomeProduto">
                        <div class="titulo-conteudo-resumo-final"> Nome do Produto Referência </div>
                        <div class="label-conteudo-resumo-final">{{InformacaoOrcamentoProdutoArray.nomeProduto}}</div>
                    </div>

                    <div class="infoBasicas-quantidade">
                        <div class="titulo-conteudo-resumo-final"> Quantidade </div>
                        <div class="label-conteudo-resumo-final" v-for="data in OrcaQuantidade"
                        :key="data.id">{{data.quantidade}}</div>
                    </div>

                    <div class="infoBasicas-diaCarregamento">
                        <div class="titulo-conteudo-resumo-final"> Dia do Carregamento </div>
                        <div class="label-conteudo-resumo-final" v-for="data in OrcaQuantidade"
                        :key="data.id">{{data.dataCarregamentoFormato}}</div>
                    </div>

                    <div class="infoBasicas-observacao">
                        <div class="titulo-conteudo-resumo-final"> Obs. sobre Quantidade / Carregamento / Consumo </div>
                        <PTextArea v-model="InformacaoObservacao" rows="4" cols="30" disabled></PTextArea> 
                    </div>
                </div>

                <div class="titulo-grupo-detalhes titulo-componentes" v-if="InformacaoOrcamentoComponenteArray.length > 0"> COMPONENTES </div>
                <div class="content-componentes">
                    <div 
                        class="box-componente" 
                        v-for="(data, index) in InformacaoOrcamentoComponenteArray"
                        :key="data.id"
                    >
                    <div class="imagem-numero-nome-componente">
                      <div class="imagem-grupo-componente">
                        <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                      </div>
                      
                      <div class="numero-nome-componente">
                        <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                        <div class="nome-componente label-conteudo">{{ data.nomeComponente }}</div>
                      </div>
                    </div> 

                    <div class="grupo-componentes">
                      <div class="componentes-medidas">
                        <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                        <div class="medidas label-conteudo">
                            {{
                                data.descMedidasEnum || data.numeroComprimento + ' x ' + data.numeroLargura + ' x ' + data.numeroAltura + ' x ' + data.numeroAlturaTampa
                            }}
                        </div>
                      </div>

                      <div class="componentes-cor-frente">
                        <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                        <div class="corFrente label-conteudo">{{ data.descCoresFrenteEnum }}</div>
                      </div>

                      <div class="componentes-cor-verso">
                        <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                        <div class="corVerso label-conteudo">{{ data.descCoresVersoEnum }}</div>
                      </div>

                      <div class="componentes-acabFrente">
                        <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                        <div class="acabFrente label-conteudo">{{ data.descAcabamentoFrenteEnum }}</div>
                      </div>

                      <div class="componentes-acabVerso">
                        <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                        <div class="acabVerso label-conteudo">{{ data.descAcabamentoVersoEnum  }}</div>
                      </div>

                      <div class="componentes-material">
                        <div class="material titulo-conteudo-detalhes"> Material </div>
                        <div class="material label-conteudo">{{ data.descMaterialEnum }}</div>
                      </div>

                      <div class="componentes-onda">
                        <div class="onda titulo-conteudo-detalhes"> Onda </div>
                        <div class="onda label-conteudo">{{ data.descOndaEnum }}</div>
                      </div>

                      <div class="componentes-capaExt">
                        <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                        <div class="capaExt label-conteudo">{{ data.descCapaExternaEnum }}</div>
                      </div>

                      <div class="componentes-gramaturaExt">
                        <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura </div>
                        <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
                      </div>

                      <div class="componentes-capaInt">
                        <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                        <div class="capaInt label-conteudo">{{ data.descCapaInternaEnum }}</div>
                      </div>

                      <div class="componentes-gramaturaInt">
                        <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura </div>
                        <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
                      </div>

                      <div class="componentes-papelOnda">
                        <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                        <div class="papelOnda label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
                      </div>

                      <div class="componentes-gramaturaPO">
                        <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura </div>
                        <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
                      </div>

                      <!-- <div class="componentes-codigo" v-if="data.descricaoSistema == 0">
                        <div class="codigo-componente titulo-conteudo-detalhes"> Código </div>
                        <div class="label-conteudo">{{ data.codigoSistema }}</div>
                      </div> -->

                      <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                        <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                        <div class="label-conteudo">{{ data.sistema }}</div>
                      </div>

                      <div class="componentes-produto" v-if="data.descricaoSistema == 2">
                        <div class="produto-comp titulo-conteudo-detalhes"> Produto </div>
                        <div class="label-conteudo">{{ data.produtoSistema }}</div>
                      </div>

                      <div class="componentes-prototipo" v-if="data.descricaoSistema == 3">
                        <div class="prototipo titulo-conteudo-detalhes"> Protótipo </div>
                        <div class="label-conteudo">{{ data.prototipoSistema }}</div>
                      </div>

                      <div class="componentes-embalagem-coletiva" 
                        v-if="data.embalagemEspecificaPalete == true || 
                            data.embalagemEspecificaFilmeEncolhivel == true || 
                            data.embalagemEspecificaCaixaColetiva == true || 
                            data.embalagemEspecificaPapelEmbrulho == true || 
                            data.quantidadeOutros != 0"
                      >
                        <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                        <div class="labels-embalagem-coletiva">
                          <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                          >
                            {{ texto }}
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="titulo-grupo-detalhes"> DEMAIS CARACTERÍSTICAS </div>
                <div class="grupo-dados-demaisCaract">
                    <div class="checklist-filtros-gerais">

                        <div class="checklist-papel-seda">
                        <div class="titulo-conteudo-resumo-final"> Papel de Seda </div>
                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="papelSeda" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Enviar Papel de Seda </label>
                        </div>
                        <div v-if="papelSeda" class="input-checkbox">
                            <label class="label-checkbox">{{ medidaPapelSeda }} X {{ medidaPapelSeda2 }}</label>
                        </div>
                    </div>

                        <div class="titulo-conteudo-resumo-final"> Gerais </div>
                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="OrcamentoGeraisFsc" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Cliente exige selo FSC nesse produto </label>
                        </div>
                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="OrcamentoGeraisLegislacao" disabled="DesabilitaCheckBox"/>
                            <label class="checkboxGerais label-checkbox"> Existe legislação ou requisito regulamentar específico </label>
                        </div>
                    </div>

                    <div class="checklist-filtros-embalagem">
                        <div class="titulo-conteudo-resumo-final"> Embalagem coletiva específica </div>
                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="OrcamentoEmbalagemFilme" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Filme encolhível </label>
                        </div>
                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="OrcamentoEmbalagemCaixaColetiva" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Caixa coletiva </label>
                        </div>
                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="OrcamentoEmbalagemPalete" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Palete </label>
                        </div>

                        <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                            <PCheckBox :binary="true" v-model="MelhorAproveitamento" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Melhor Aproveitamento </label>
                        </div>

                        <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                            <label class="label-checkbox"> C: {{ComprimentoPalete}} X L: {{LarguraPalete}} X A: {{AlturaPalete}} </label>
                        </div>

                        <div v-if="OrcamentoEmbalagemPalete" class="input-checkbox">
                            <label class="label-checkbox"> Obs. Palete: {{ObservacaoPalete}} </label>
                        </div>

                        <div class="input-checkbox">
                            <PCheckBox :binary="true" v-model="OrcamentoEmbalagemOutros" disabled="DesabilitaCheckBox"/>
                            <label class="label-checkbox"> Outros </label>
                        </div>

                        <div v-if="OrcamentoEmbalagemDescOutros" class="input-checkbox">
                            <label class="label-conteudo">{{OrcamentoEmbalagemDescOutros}}</label>
                        </div>
                    </div>

                    <div class="checklist-filtros-critica">
                        <div class="titulo-conteudo-resumo-final"> Crítica de processo </div>
                        <div class="input-checkbox critica-container">
                            <label class="label-conteudo-resumo-final"> O produto terá fechamento por máquina por parte do cliente? </label> 
                            <label :class="`label-checkbox critica-bool ${OrcamentoCritica3 ? 'botao-positivo' : 'botao-negativo'}`" for="fechamento-maquina">
                                {{ OrcamentoCritica3 ? "SIM" : "NÃO" }}
                            </label>
                        </div>
                    </div>

                    <div class="demaisCaract-observacoes">
                        <div class="titulo-conteudo-resumo-final"> Observações </div>
                        <PTextArea v-model="InformacaoObservacoesGerais" rows="4" cols="30" disabled></PTextArea> 
                    </div>
                </div>
            </div>

            <div class="buttons-next-back">
                <div class="button-next">
                    <g-button
                    tipo="amarelo"
                    altura="35px"
                    largura="100%"
                    negritoTexto 
                    @click="novo_orcamento()" 
                    >
                        NOVO ORÇAMENTO
                    </g-button>
                </div>

                <div class="button-back">
                    <g-button 
                    tipo="cinza" 
                    altura="35px"
                    largura="100%"
                    negritoTexto 
                    v-on:acao="consultarorcamento()" 
                    >
                        VER ORÇAMENTOS
                    </g-button>
                </div>
            </div>
        </g-card>
    </div>
</template>

<script>
import OrcamentoFinalRA from './OrcamentoFinalRA.js'
export default OrcamentoFinalRA
</script>

<style scoped>
.img-info-mobile {
  font-size: 13px;
  font-family: "MontSerrat";
  letter-spacing: 0px;
  color: #CECECE;
  width: auto;
  margin: 10px 10px;
}

.container-logo {
  padding: 30px 30px 10px 53px;
}
.cor-numero {
    color: #fcb316;
    font-family: "MontSerrat";
    font-weight: 700;
}
.header-icons {
    justify-content: end;
}

.button-back, .button-next {
  width: 14em;
}

.content-componentes {
    width: 100%;
    display: grid;
    gap: 1.5rem;
}
.box-componente {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente .grupo-componentes {
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
}

.titulo-componentes {
    margin-bottom: 1.5rem;
}
.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
}

.titulo-conteudo-detalhes {
  color: #3f3f3f;
  margin-top: 0.1rem;
}

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

.checklist-filtros-critica .label-checkbox, .label-conteudo-resumo-final {
    margin: 0;
}

.critica-container {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.critica-bool {
  color: #F9F9F9;
  width: max-content;
  padding: 0.2rem 1rem;
  border-radius: 0.2rem;
}

.botao-positivo {
  background-color: #3dca55;
}
.botao-negativo {
  background-color: #DC4242;
}

.checklist-filtros-gerais {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.grupo-dados-demaisCaract {
    row-gap: 1.5rem;
}

.titulo-grupo-detalhes {
    padding: 50px 0 10px;
}

@media (min-width: 310px) {
.container-numero {
    display: flex;
    justify-content: center;
}
.header-card-resumo-final {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(6, auto);
    grid-column-gap: 20px;
    grid-row-gap: 10px;
}
.header-icons { grid-area: 1 / 1 / 2 / 3; }
.resumo-final-imagem { grid-area: 2 / 1 / 4 / 3; }
.resumo-final-img { height: 6em; }
.titulo-resumo-final { grid-area: 4 / 1 / 5 / 3; text-align: center; flex-wrap: wrap;}
.subtitulo-resumo-final { display: none; }
.linha-separacao { grid-area: 5 / 1 / 6 / 3; margin: 10px 0 5px; }
.unidade-representante { grid-area: 6 / 1 / 7 / 3; }

.grupo-dados-infoBasicas {
    display: grid;
    grid-template-columns: minmax(4em, 1fr);
    grid-template-rows: repeat(5, auto);
    grid-column-gap: 20px;
}
.infoBasicas-imagemProduto { 
    grid-area: 1 / 1 / 3 / 2;
    justify-self: center;
    align-self: center;
}
.infoBasicas-nomeProduto { grid-area: 3 / 1 / 4 / 2; }
.infoBasicas-quantidade { grid-area: 4 / 1 / 5 / 2; }
.infoBasicas-diaCarregamento { grid-area: 5 / 1 / 6 / 2; }
.infoBasicas-observacao { grid-area: 6 / 1 / 7 / 2; }

.img-componente {
  height: 2.5rem;
  width: auto;
}

.titulo-conteudo-detalhes, .label-conteudo {
  font-size: 0.8rem;
}
}

@media (min-width:400px) {
.grupo-dados-cliente {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(7, auto);
    grid-column-gap: 20px;
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razaosocial { grid-area: 2 / 1 / 3 / 3; }
.cliente-estado { grid-area: 3 / 1 / 4 / 2; }
.cliente-cidade { grid-area: 3 / 2 / 4 / 3; }
.cliente-segmento { grid-area: 4 / 1 / 5 / 3; }
.cliente-contato { grid-area: 5 / 1 / 6 / 2; }
.cliente-telefone { grid-area: 5 / 2 / 6 / 3; }
.cliente-ramal { grid-area: 6 / 1 / 7 / 2; }
.cliente-suframa { grid-area: 6 / 2 / 7 / 3; }
.cliente-incentivo { grid-area: 7 / 1 / 8 / 3; }

.grupo-dados-loteFrete {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(v-bind(RetornaQtdLinha1()), auto);
    grid-column-gap: 20px;
}
.lotefrete-riscofaca { grid-area: 1 / 1 / 2 / 2; }
.loteFrete-prototipo { grid-area: 1 / 2 / 2 / 3; }
.lotefrete-lote { grid-area: 2 / 1 / 3 / 2; }
.loteFrete-descricao-lote { grid-area: 2 / 2 / 3 / 3; }
.lotefrete-sequencia { grid-area: v-bind(GridSequencia1()) }
.loteFrete-descricao-sequencia { grid-area: v-bind(GridDescricaoSequencia1()) }
.lotefrete-frete { grid-area: 4 / 1 / 5 / 2; }
.lotefrete-estado { grid-area: 4 / 2 / 5 / 3; }
.lotefrete-cidade { grid-area: 5 / 1 / 6 / 2; }
.lotefrete-tipoFrete { grid-area: 5 / 2 / 6 / 3; }

.grupo-dados-infoBasicas {
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
}
.infoBasicas-nomeProduto { grid-area: 1 / 1 / 2 / 4; }
.infoBasicas-quantidade { grid-area: 2 / 1 / 3 / 3; }
.infoBasicas-diaCarregamento { grid-area: 2 / 2 / 3 / 4; }
.infoBasicas-amostraRef { grid-area: 3 / 1 / 4 / 4; }
.infoBasicas-observacao { grid-area: 4 / 1 / 5 / 4; }
}

@media (min-width: 450px) {
.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }    
}

@media (min-width:500px) {
.container-numero {
    display: flex;
    justify-content: left;
}
.header-card-resumo-final {
    grid-template-columns: minmax(4em, 0.3fr) minmax(4em, 1fr) minmax(4em, 0.3fr);
    grid-template-rows: repeat(3, auto);
}
.resumo-final-imagem { grid-area: 1 / 1 / 2 / 2; justify-self: self-start; }
.resumo-final-img { height: 4.5em; }
.titulo-resumo-final { grid-area: 1 / 2 / 2 / 3; display: flex; }
.header-icons { grid-area: 1 / 3 / 2 / 4; }
.linha-separacao { grid-area: 2 / 1 / 3 / 4; }
.unidade-representante { grid-area: 3 / 1 / 4 / 4; }

.titulo-conteudo-detalhes, .label-conteudo {
  font-size: 0.9rem;
}

.componentes-embalagem-coletiva { 
    grid-column: span 2; 
}
}

@media (min-width:600px) {
.resumo-final-img {
    height: 5em;
}
.grupo-dados-cliente, .grupo-dados-loteFrete {
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
}
.cliente-cnpj, .lotefrete-riscofaca { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo, .loteFrete-prototipo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razaosocial, .lotefrete-lote { grid-area: 1 / 3 / 2 / 4; }
.cliente-estado, .loteFrete-descricao-lote { grid-area: 2 / 1 / 3 / 2; }
.cliente-cidade{ grid-area: 2 / 2 / 3 / 3; }
.cliente-segmento{ grid-area: 2 / 3 / 3 / 4; }
.cliente-contato, .lotefrete-frete { grid-area: 3 / 1 / 4 / 2; }
.cliente-telefone, .lotefrete-estado { grid-area: 3 / 2 / 4 / 3; }
.cliente-ramal, .lotefrete-cidade { grid-area: 3 / 3 / 4 / 4; }
.cliente-suframa, .lotefrete-tipoFrete { grid-area: 4 / 1 / 5 / 2; }
.cliente-incentivo { grid-area: 4 / 2 / 5 / 4; }

.grupo-dados-loteFrete {
    grid-template-columns: repeat(3, repeat(4em, 1fr));
    grid-template-rows: repeat(4, auto);
}
.lotefrete-riscofaca { grid-area: 1 / 1 / 2 / 2; }
.loteFrete-prototipo { grid-area: 1 / 2 / 2 / 3; }
.lotefrete-lote { grid-area: 1 / 3 / 2 / 4; }
.loteFrete-descricao-lote { grid-area: 2 / 1 / 3 / 2; }
.lotefrete-sequencia { grid-area: v-bind(GridSequencia2()) }
.loteFrete-descricao-sequencia { grid-area: v-bind(GridDescricaoSequencia2()) }
.lotefrete-frete { grid-area: 3 / 1 / 4 / 2; }
.lotefrete-estado { grid-area: 3 / 2 / 4 / 3; }
.lotefrete-cidade { grid-area: 3 / 3 / 4 / 4; }
.lotefrete-tipoFrete { grid-area: 4 / 1 / 5 / 2; }


.content-componentes {
    grid-template-columns: repeat(2, minmax(2rem, 1fr));
}

.componentes-produto, 
.componentes-embalagem-coletiva { grid-column: span 2; } 


.grupo-dados-infoBasicas {
    grid-template-columns: repeat(2, minmax(4em, 1fr));
}
.infoBasicas-imagemProduto { grid-area: 1 / 1 / 3 / 2; }
.infoBasicas-nomeProduto { grid-area: 1 / 2 / 2 / 3; }
.infoBasicas-quantidade { grid-area: 3 / 1 / 4 / 2; }
.infoBasicas-diaCarregamento { grid-area: 3 / 2 / 4 / 3; }
.infoBasicas-observacao { grid-area: 4 / 1 / 5 / 3; }
}

@media (min-width:801px) {
.header-card-resumo-final {
    display: grid;
    grid-template-columns: repeat(2, 0.8fr) repeat(2, minmax(4em, 7.5fr)) repeat(2, 1.5fr);
    grid-template-rows: repeat(4, auto);
    grid-column-gap: 20px;
    grid-row-gap: 0px;
}
.resumo-final-imagem { grid-area: 1 / 1 / 3 / 3; }
.titulo-resumo-final { grid-area: 1 / 3 / 2 / 5; text-align: left; }
.subtitulo-resumo-final { grid-area: 2 / 3 / 3 / 5; display: block; }
.header-icons { grid-area: 1 / 5 / 2 / 7; }
.linha-separacao { grid-area: 3 / 1 / 4 / 7; margin: 15px 0 10px; }
.unidade-representante { grid-area: 4 / 1 / 5 / 7; }

.grupo-dados-cliente, .grupo-dados-loteFrete {
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
}

.lotefrete-frete { grid-area: 3 / 1 / 4 / 2; }
.lotefrete-estado { grid-area: 3 / 2 / 4 / 3; }
.lotefrete-cidade { grid-area: 3 / 3 / 4 / 4; }
.lotefrete-tipoFrete { grid-area: 3 / 4 / 4 / 5; }
.lotefrete-sequencia { grid-area: v-bind(GridSequencia3()) }
.loteFrete-descricao-sequencia { grid-area: v-bind(GridDescricaoSequencia3()) }


.cliente-estado, .loteFrete-descricao-lote { grid-area: 1 / 4 / 2 / 5; }
.cliente-cidade{ grid-area: 2 / 1 / 3 / 2; }
.cliente-segmento{ grid-area: 2 / 2 / 3 / 3; }
.cliente-contato{ grid-area: 2 / 3 / 3 / 4; }
.cliente-telefone{ grid-area: 2 / 4 / 3 / 5; }
.cliente-ramal{ grid-area: 3 / 1 / 4 / 2; }
.cliente-suframa{ grid-area: 3 / 2 / 4 / 3; }
.cliente-incentivo { grid-area: 3 / 3 / 4 / 4; }

.grupo-dados-infoBasicas {
    grid-template-columns: minmax(4em, 1fr) repeat(2, minmax(4em, 0.5fr)) minmax(4em, 1fr);
    grid-template-rows: repeat(3, auto);
}
.infoBasicas-imagemProduto { grid-area: 1 / 1 / 3 / 3; }
.infoBasicas-nomeProduto { grid-area: 1 / 3 / 2 / 5; }
.infoBasicas-quantidade { grid-area: 2 / 3 / 3 / 4; }
.infoBasicas-diaCarregamento { grid-area: 2 / 4 / 3 / 5; }
.infoBasicas-observacao { grid-area: 3 / 1 / 4 / 5; }
}

@media (min-width:1025px) {
 .lado_a_lado{
    display: grid;
    grid-template-columns: repeat(2, 1fr);   
}
.header-card-resumo-final {
    grid-template-columns: repeat(2, 0.6fr) repeat(2, minmax(4em, 4.4fr)) repeat(2, 3fr);
    grid-template-rows: repeat(2, auto);
    grid-row-gap: 10px;
}
.linha-separacao { display: none; }
.unidade-representante { grid-area: 2 / 5 / 3 / 7; justify-self: flex-end; }


.content-componentes {
  column-gap: 4rem;
}
.imagem-numero-nome-componente {
    padding: 0.5rem 1rem;
}
.grupo-componentes {
    padding: 0 1rem;
}


.grupo-dados-demaisCaract {
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    grid-column-gap: 20px;
}
.checklist-filtros-gerais { grid-area: 1 / 1 / 2 / 2; }
.checklist-filtros-embalagem { grid-area: 1 / 2 / 2 / 3; }
.checklist-filtros-critica { grid-area: 2 / 1 / 3 / 3; }
.demaisCaract-observacoes { grid-area: 3 / 1 / 4 / 3; }
}

@media (min-width:1281px) {
.grupo-dados-cliente {
    grid-template-columns: repeat(5, minmax(auto, 1fr));
    grid-template-rows: repeat(3, auto);
}
.cliente-cnpj { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razaosocial { grid-area: 1 / 3 / 2 / 4; }
.cliente-estado { grid-area: 1 / 4 / 2 / 5; }
.cliente-cidade { grid-area: 1 / 5 / 2 / 6; }
.cliente-segmento { grid-area: 2 / 1 / 3 / 2; }
.cliente-contato { grid-area: 2 / 2 / 3 / 3; }
.cliente-telefone { grid-area: 2 / 3 / 3 / 4; }
.cliente-ramal { grid-area: 2 / 4 / 3 / 5; }
.cliente-suframa { grid-area: 2 / 5 / 3 / 6; }
.cliente-incentivo { grid-area: 3 / 1 / 4 / 2; }

.grupo-dados-loteFrete {
    grid-template-columns: repeat(6, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
}
.lotefrete-riscofaca { grid-area: 1 / 1 / 2 / 2; }
.loteFrete-prototipo { grid-area: 1 / 2 / 2 / 3; }
.lotefrete-lote { grid-area: 1 / 3 / 2 / 4; }
.loteFrete-descricao-lote { grid-area: 1 / 4 / 2 / 5; }
.lotefrete-sequencia { grid-area: v-bind(GridSequencia4()) }
.loteFrete-descricao-sequencia { grid-area: v-bind(GridDescricaoSequencia4()) }
.lotefrete-frete { grid-area: 3 / 1 / 4 / 2; }
.lotefrete-estado { grid-area: 3 / 2 / 4 / 3; }
.lotefrete-cidade { grid-area: 3 / 3 / 4 / 4; }
.lotefrete-tipoFrete { grid-area: 3 / 4 / 4 / 5; }


.content-componentes {
    grid-template-columns: repeat(3, minmax(2rem, 1fr));
    column-gap: 1.5rem;
}

.imagem-numero-nome-componente, .grupo-componentes {
    padding: 0;
}

.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
.componentes-embalagem-coletiva { grid-column: span 2; }


.grupo-dados-demaisCaract {
    grid-template-columns: minmax(4em, 1.5fr) repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
}
.checklist-filtros-gerais { grid-area: 1 / 1 / 2 / 2; }
.checklist-filtros-embalagem { grid-area: 1 / 2 / 2 / 3; }
.checklist-filtros-critica { grid-area: 2 / 1 / 3 / 4; }
.demaisCaract-observacoes { grid-area: 3 / 1 / 4 / 4; }

.grupo-dados-infoBasicas {
    grid-template-columns: minmax(4em, 1.4fr) minmax(4em, 1.3fr) minmax(4em, 0.5fr) minmax(4em, 1fr);
    grid-template-rows: repeat(2, auto);
}
.infoBasicas-imagemProduto { grid-area: 1 / 1 / 2 / 2; }
.infoBasicas-nomeProduto { grid-area: 1 / 2 / 2 / 3; }
.infoBasicas-quantidade { grid-area: 1 / 3 / 2 / 4; }
.infoBasicas-diaCarregamento { grid-area: 1 / 4 / 2 / 5; }
.infoBasicas-observacao { grid-area: 2 / 1 / 3 / 5; }
}

@media (min-width:1400px) {
.header-card-resumo-final {
    grid-template-columns: repeat(2, 0.4fr) repeat(2, minmax(4em, 4.4fr)) repeat(2, 3fr);
}

.grupo-dados-infoBasicas {
    grid-template-columns: minmax(4em, 2fr) minmax(4em, 1.5fr) repeat(2, minmax(4em, 1fr)) 1fr;
}
.infoBasicas-observacao { grid-area: 2 / 1 / 3 / 6; }
}

@media (min-width:1500px) {
.resumo-final-img {
    height: 5.5em;
}

.grupo-dados-cliente, .grupo-dados-loteFrete {
    grid-template-columns: repeat(6, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
}

.lotefrete-frete { grid-area: 2 / 1 / 3 / 2; }
.lotefrete-estado { grid-area: 2 / 2 / 3 / 3; }
.lotefrete-cidade { grid-area: 2 / 3 / 3 / 4; }
.lotefrete-tipoFrete { grid-area: 2 / 4 / 3 / 5; }


.cliente-cnpj, .lotefrete-riscofaca { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo, .loteFrete-prototipo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razaosocial, .lotefrete-lote { grid-area: 1 / 3 / 2 / 4; }
.cliente-estado, .loteFrete-descricao-lote { grid-area: 1 / 4 / 2 / 5; }
.cliente-cidade{ grid-area: 1 / 5 / 2 / 6; }
.cliente-segmento{ grid-area: 1 / 6 / 2 / 7; }
.cliente-contato{ grid-area: 2 / 1 / 3 / 2; }
.cliente-telefone{ grid-area: 2 / 2 / 3 / 3; }
.cliente-ramal{ grid-area: 2 / 3 / 3 / 4; }
.cliente-suframa{ grid-area: 2 / 4 / 3 / 5; }
.cliente-incentivo { grid-area: 2 / 5 / 3 / 6; }


.content-componentes {
    grid-template-columns: repeat(4, minmax(2rem, 1fr));
}

.grupo-dados-demaisCaract {
    grid-template-columns: minmax(4em, 1.5fr) repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
}
.checklist-filtros-gerais { grid-area: 1 / 1 / 2 / 2; }
.checklist-filtros-embalagem { grid-area: 1 / 2 / 2 / 3; }
.checklist-filtros-critica { grid-area: 2 / 1 / 3 / 5; }
.demaisCaract-observacoes { grid-area: 3 / 1 / 4 / 5; }
}

@media(min-width:1700)
{
    .lado_a_lado{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}
}

@media (min-width:1800px) {
.grupo-dados-cliente, .grupo-dados-loteFrete {
    grid-template-columns: repeat(7, minmax(4em, 1fr));
}

.lotefrete-frete { grid-area: 2 / 1 / 3 / 2; }
.loteFrete-estado { grid-area: 2 / 2 / 3 / 3; }
.lotefrete-cidade { grid-area: 2 / 3 / 3 / 4; }
.lotefrete-tipoFrete { grid-area: 2 / 4 / 3 / 5; }

.cliente-contato{ grid-area: 1 / 7 / 2 / 8; }
.cliente-telefone { grid-area: 2 / 1 / 3 / 2; }
.cliente-ramal{ grid-area: 2 / 2 / 3 / 3; }
.cliente-suframa{ grid-area: 2 / 3 / 3 / 4; }
.cliente-incentivo { grid-area: 2 / 4 / 3 / 5; }
}

@media (min-width:2000px) {

.header-card-resumo-final {
    grid-template-columns: repeat(2, 0.4fr) repeat(2, minmax(4em, 5fr)) repeat(2, 3fr);
    grid-template-rows: auto;
}
.resumo-final-img {
    height: 6.5em;
}

.grupo-dados-cliente, .grupo-dados-loteFrete  {
    grid-template-columns: repeat(8, minmax(4em, 1fr));
}
.cliente-telefone, .lotefrete-estado { grid-area: 1 / 8 / 2 / 9; }
.cliente-ramal, .lotefrete-cidade { grid-area: 2 / 1 / 3 / 2; }
.cliente-suframa, .lotefrete-tipoFrete { grid-area: 2 / 2 / 3 / 3; }
.cliente-incentivo { grid-area: 2 / 3 / 3 / 4; }
}

@media (min-width:2500px) {
.resumo-final-img {
    height: 6.5em;
}

.grupo-dados-cliente, .grupo-dados-loteFrete {
    grid-template-columns: repeat(10, minmax(4em, 1fr));
}
.grupo-dados-cliente {
    grid-template-rows: repeat(2, auto);
}
.grupo-dados-loteFrete {
    grid-template-rows: auto;
}

.lotefrete-frete { grid-area: 2 / 1 / 3 / 2; }
.loteFrete-estado { grid-area: 2 / 2 / 3 / 3; }
.lotefrete-cidade { grid-area: 2 / 3 / 3 / 4; }
.lotefrete-tipoFrete { grid-area: 2 / 4 / 3 / 5; }


.cliente-cnpj, .lotefrete-riscofaca { grid-area: 1 / 1 / 2 / 2; }
.cliente-codigo, .loteFrete-prototipo { grid-area: 1 / 2 / 2 / 3; }
.cliente-razaosocial, .lotefrete-lote { grid-area: 1 / 3 / 2 / 4; }
.cliente-estado, .loteFrete-descricao-lote { grid-area: 1 / 4 / 2 / 5; }
.cliente-cidade{ grid-area: 1 / 5 / 2 / 6; }
.cliente-segmento{ grid-area: 1 / 6 / 2 / 7; }
.cliente-contato { grid-area: 1 / 7 / 2 / 8; }
.cliente-telefone { grid-area: 1 / 8 / 2 / 9; }
.cliente-ramal{ grid-area: 1 / 9 / 2 / 10; }
.cliente-suframa{ grid-area: 1 / 10 / 2 / 11; }
.cliente-incentivo { grid-area: 2 / 1 / 3 / 2; }

.grupo-dados-demaisCaract {
    grid-template-columns: 1.5fr repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
}
.checklist-filtros-gerais { grid-area: 1 / 1 / 2 / 2; }
.checklist-filtros-embalagem { grid-area: 1 / 2 / 2 / 3; }
.checklist-filtros-critica { grid-area: 2 / 1 / 3 / 6; }
.demaisCaract-observacoes { grid-area: 3 / 1 / 4 / 6; }
}
</style>